<p-panel>
    <ng-container *ngIf="isReactiveFormReady; else reactiveFormLoadingState">
        <div class="container-fluid gap-5">
            <div class="row">
                <div class="col">
                    <app-reactive-form-builder
                      (goBack)="goBack()"
                      (internalLifecycleEvents)="onReactiveFormLifecycleEvent($event)"
                      (stableValueChanges)="stableValueChanges($event)"
                      [form]="form.formFields"
                      [serverUrl]="form.env.auxServerUrl"
                      [id]="reactiveFormRecordId"
                      [request]="request"
                      [getRequest]="getRequest"
                      [previousData]="initialPreviousData"
                      [undoEnabled]="undoEnabled">
                    </app-reactive-form-builder>
                </div>
            </div>
        </div>
    </ng-container>
</p-panel>

<ng-template #reactiveFormLoadingState>
    <div class="p-3 text-center" role="status" aria-live="polite">
        <div *ngIf="!reactiveFormLoadingError" class="text-muted">
            {{ reactiveFormLoadingLabel }}
        </div>
        <div *ngIf="reactiveFormLoadingError" class="alert alert-danger mb-0" role="alert">
            {{ reactiveFormLoadingError }}
        </div>
    </div>
</ng-template>

<p-dialog
  *ngIf="form"
  [(visible)]="form.openDialog"
  [modal]="true"
  [dismissableMask]="true"
  header="Añadir valor"
  [style]="{ width: '28rem' }"
>
  <form [formGroup]="comunidadForm" class="p-fluid" (ngSubmit)="saveNewOption()">

    <div class="field">
      <label for="nombre">Nombre</label>
      <input
        id="nombre"
        pInputText
        formControlName="nombre"
      />
      <small
        *ngIf="comunidadForm.controls['nombre']?.invalid && comunidadForm.controls['nombre']?.touched"
        class="p-error"
      >
        Campo requerido
      </small>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" (click)="form.openDialog = false" label="Cancelar"></button>
    <button pButton type="button" (click)="saveNewOption()" label="Añadir" icon="pi pi-check"></button>
  </ng-template>
</p-dialog>
